import React, { useContext } from 'react'
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import styles from './TicketList.module.css'
import { ZendeskContext } from '../../store/zendesk-context'
import SessionsList from './SessionsList';
import { Link } from 'react-router-dom';
import { URL } from '../../constants';
import { AuthContext } from '../../store/auth-context';


const TicketItems = (props: any) => {

	const zendeskCtx = useContext(ZendeskContext)
	const authCtx = useContext(AuthContext)

	const list = zendeskCtx?.historyData && zendeskCtx?.historyData?.length && zendeskCtx?.historyData.map((ticket, idx) => {
		let processedCount = 0
		ticket?.conversations.map((conversation: any, cIdx: number) => {
			if(conversation.is_processed) {
				processedCount++
			}
		})
		let showORHide = ticket.ticket_id.indexOf(props.searchedFromListID) == 0 ? '' : 'd-none';
		return 	<li key={`${ticket.ticket_id}-${idx}`} className={`${showORHide} ${zendeskCtx.activeTickets.includes(idx) ? styles.ticketActive : null}`}>
					<div className={`${styles.ticketDetails} py-4`}>
						<div className={styles.ticketTitle} onClick={() => zendeskCtx.updateActiveTickets(idx)}>
							{ticket.ticket_title}
							<span className={styles.toggleSession}></span>
						</div>
						<div>{ticket.ticket_id}</div>
						<div className='text-center'>{ticket.conversations_count}</div>
						<div>{moment.tz(ticket.conversations[0].date_time, "UTC").format('MMMM DD, YYYY')}</div>
						<div className={processedCount == ticket.conversations_count ? styles.processed : styles.processing}>
							{
								processedCount == ticket.conversations_count ?
								<Link to={`/${authCtx.currentTenant}/${URL.conversation}/${ticket.ticket_id.trim()}${ticket.conversations[0].session_id ? `?session_id=${ticket.conversations[0].session_id}` : ''}`}>View Conversation</Link> :
									`Processing ${ticket.conversations_count - processedCount} of ${ticket.conversations_count}...`
							}
						</div>
					</div>
					{
						zendeskCtx.activeTickets.includes(idx) ?
							<div className={styles.ticketContainer}>
								<SessionsList
									threadID={ticket.ticket_id}
									ticketIdx={idx}
									conversations={ticket.conversations}
								/>
							</div> :
							null

					}
					
				</li>
	}) 

	return (
		<ul className={styles.ticketListItems}>
			{list}
		</ul>
	)
}

export default TicketItems